
<!-- <div>
  <button (click)="openModal('custom-modal-1')">Open Modal 1</button>
  <button (click)="openModal('custom-modal-2')">Open Modal 2</button>
</div> -->



<div (click)="openModal('custom-modal-1')"  class="dayPointer;" [style.background-color]="
altMonth === 'pre' ? 'rgba('+ preSignColor +', 1)' :
altMonth === 'post' ? 'rgba('+ postSignColor +', 1)' :
todayIs < transferDate ? 'rgba('+ preSignColor +', 0.6)' : 'rgba('+ postSignColor +', 0.6)'"
 > 
<!-- <div> -->

 
 <!--BG PRE COLOR -->

<!-- <div> -->
  <div [ngStyle]="backgroundType"> 
    <!--CUSP TRANS LAYER -->

<div style="border: solid 1px gray; padding:5px;" [class.todaySun]="todaySun" >

  <img
    *ngIf="
      (altMonth === 'na' && todayIs === fullMoon) ||
      (altMonth === 'na' && todayIs === fullMoon2)
    "
    src="../../../calendar/assets/img/fullmoon.png"
    alt="Full Moon"
    height={{moonSize}}
    width={moonSize}}
    class="moon"
  />
  <img
    *ngIf="
      (altMonth === 'na' && todayIs === newMoon) ||
      (altMonth === 'na' && todayIs === newMoon2)
    "
    src="../../../calendar/assets/img/newmoon.png"
    alt="Full Moon"
    height={{moonSize}}
    width={moonSize}}
    class="moon"
  />
  <img
    *ngIf="
      (altMonth === 'na' && todayIs === firstqmoon) ||
      (altMonth === 'na' && todayIs === firstqmoon2)
    "
    src="../../../calendar/assets/img/firstqmoon.png"
    alt="Full Moon"
    height={{moonSize}}
    width={moonSize}}
    class="moon"
  />
  <img
    *ngIf="
      (altMonth === 'na' && todayIs === lastqmoon) ||
      (altMonth === 'na' && todayIs === lastqmoon2)
    "
    src="../../../calendar/assets/img/lastqmoon.png"
    alt="Full Moon"
    height={{moonSize}}
    width={moonSize}}
    class="moon"
  />
  <p class="date GeneralTxt" [style.color]="todayIs === 0 ? 'rgba(0, 0, 0, 0)' : 'rgba(0, 0, 0, 1)'">
    {{ todayIs }}</p>

    
    <p
    class="BOS activeIcon centerIcon"
    [ngClass]="{
      altMonthIconSize: altMonth === 'pre' || altMonth === 'post',
      currentMonthIconSize: altMonth === 'na',
      cuspIconSize: cusp === true 
    }"  >{{ displayIcon }}
  </p>
</div>


</div>
 
</div>

<!-- Modals -->


<jw-modal id="custom-modal-1">
  <button mat-raised-button (click)="closeModal('custom-modal-1');">Close</button>
</jw-modal>




<!-- <jw-modal id="custom-modal-2">
  <h1 style="height:1000px">A Tall Custom Modal Window!</h1>
  <button (click)="closeModal('custom-modal-2');">Close</button>
</jw-modal> -->